import React from 'react';
import { Outlet } from 'react-router-dom';
function CreateAO() {
    return (
        <>
            <Outlet />
        </>
    );
}

export default CreateAO;